var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_575_8974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9619 28.2231L50.5185 33.3666L55.0803 28.2231H45.9619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5184 34.2758C50.2556 34.2758 50.0033 34.1615 49.8246 33.9641L45.2628 28.8258C45.0263 28.5557 44.9685 28.1764 45.1157 27.8491C45.2628 27.5218 45.5939 27.314 45.9513 27.314H55.0749C55.4376 27.314 55.7634 27.5218 55.9106 27.8491C56.0577 28.1712 55.9999 28.5557 55.7634 28.8258L51.2016 33.9641C51.0282 34.1615 50.7759 34.2758 50.5079 34.2758H50.5184ZM47.9852 29.1375L50.5184 31.9898L53.0516 29.1375H47.9904H47.9852Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6131 30.9093C50.1033 30.9093 49.6934 30.5041 49.6934 30.0002C49.6934 21.407 44.5009 13.723 36.4651 10.4291C35.9974 10.2369 35.7714 9.70695 35.9658 9.23936C36.1603 8.77697 36.7016 8.55357 37.1694 8.7458C45.8936 12.3202 51.5276 20.664 51.5276 29.995C51.5276 30.4989 51.1176 30.9041 50.6078 30.9041L50.6131 30.9093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2664 53C25.1866 53 22.191 52.4129 19.3635 51.2491C10.6392 47.6747 5 39.3309 5 30C5 26.9555 5.59388 23.9941 6.76587 21.199C10.387 12.5747 18.8221 7 28.2664 7C28.7762 7 29.1861 7.40524 29.1861 7.90919C29.1861 8.41315 28.7762 8.81839 28.2664 8.81839C19.5684 8.81839 11.8007 13.9514 8.46867 21.8952C7.38603 24.4721 6.83945 27.1997 6.83945 30C6.83945 38.5932 12.0319 46.2772 20.0677 49.571C22.6745 50.6413 25.4336 51.1816 28.2664 51.1816C36.9591 51.1816 44.7321 46.0486 48.0641 38.1048C48.2586 37.6424 48.7999 37.4242 49.2676 37.6112C49.7354 37.8035 49.9614 38.3334 49.7669 38.801C46.1511 47.4253 37.7106 53 28.2716 53H28.2664Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2664 30.6964C27.7566 30.6964 27.3467 30.2912 27.3467 29.7872V13.6192C27.3467 13.1152 27.7566 12.71 28.2664 12.71C28.7762 12.71 29.1861 13.1152 29.1861 13.6192V29.7872C29.1861 30.2912 28.7762 30.6964 28.2664 30.6964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9696 39.5127C36.7331 39.5127 36.4966 39.4244 36.3179 39.2478L27.1259 30.161C26.7686 29.8077 26.7686 29.231 27.1259 28.8778C27.4833 28.5245 28.0667 28.5245 28.4241 28.8778L37.6161 37.9645C37.9734 38.3178 37.9734 38.8945 37.6161 39.2478C37.4374 39.4244 37.2009 39.5127 36.9644 39.5127H36.9696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.826 30.0002C30.826 28.6026 29.6802 27.4648 28.2612 27.4648C26.8422 27.4648 25.6965 28.5974 25.6965 30.0002C25.6965 31.403 26.8422 32.5355 28.2612 32.5355C29.6802 32.5355 30.826 31.403 30.826 30.0002Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_575_8974"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 46,
    fill: "white",
    transform: "translate(5 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon_time.accd03f8bb5b3d18c97f935de0c41d7c.svg";
export { ForwardRef as ReactComponent };